import axios from 'axios'
import { useState } from 'react'

// axios.defaults.baseURL = process.env.REACT_APP_API_URL;
axios.defaults.baseURL = 'http://money-exchanger.localhost/api';
if (window.location.href.indexOf('me.sanacommissionagent.com.pk') > 0) {
  axios.defaults.baseURL = 'https://be.sanacommissionagent.com.pk/api';
} else if (window.location.href.indexOf('sanacommissionagent.com.pk') > 0) {
  axios.defaults.baseURL = 'https://admin.sanacommissionagent.com.pk/api';
}

const useAxios = (cbAction) => {
  const [error, setError] = useState('');

  const fetchData = ({ url, method, body = null, headers = null }) => {
    axios({
      url: url,
      method: method,
      headers: headers,
      data: body
    })
      .then(function (response) {
        cbAction(response);
      })
      .catch(function (error) {
        cbAction(error.response);
      })
  }

  return [error, fetchData];
}

export default useAxios;